import { gql } from 'urql';

const SaveHowDoYouGetPaidSelection = gql`
  mutation SaveHowDoYouGetPaidSelection(
    $input: SaveHowDoYouGetPaidSelectionInput!
  ) {
    saveHowDoYouGetPaidSelection(input: $input) {
      __typename
      ... on SaveHowDoYouGetPaidSelectionSuccess {
        success
      }
      ... on SaveHowDoYouGetPaidSelectionError {
        code
        message
        title
      }
    }
  }
`;

export default SaveHowDoYouGetPaidSelection;
